export default __webpack_public_path__ + "static/media/download (6).5adbd5f7.jpg";